import { render } from "./Simulator.vue?vue&type=template&id=006f8137&scoped=true"
import script from "./Simulator.vue?vue&type=script&lang=js"
export * from "./Simulator.vue?vue&type=script&lang=js"

import "./Simulator.vue?vue&type=style&index=0&id=006f8137&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006f8137"]])

export default __exports__